export const DEFAULT_STATE = {
    data: null,
    dataChecked: null,
    isLoading: false,
    valuesSelected: [],
};
